module.exports = __webpack_public_path__ + "img/logo1 (43).83a0201e.jpg";